<template>
  <div class="login">
    <div class="left">
      <img src="@/static/login/left-bg.png" class="left-bg" alt="" />
      <div class="login-text">
        <img src="@/static/login/login-logo.png" class="logo" alt="" />
        <div class="text1">土石方行业</div>
        <div class="text2">全流程数字化管理平台</div>
      </div>
      <div class="bottom-tags">
        <div class="tag">项目全流程管理</div>
        <div class="tag">智能签单进出场</div>
        <div class="tag">撮合促成交易</div>
      </div>
    </div>
    <div class="right">
      <img src="@/static/login/right-background.png" class="right-bg" alt="">
      <div class="form-header-top">
        <div class="title">捷运途 · 云账号登录</div>
        <div class="right-text">
          <div class="active-text" @click="$router.push({ path: '/garbageRegister' })">注册泥尾</div>
          <div class="active-text" @click="$router.push({ path: '/companyAuth' })">注册企业</div>
        </div>
      </div>
      <div class="tabs">
        <div :class="['tab',curTab==2?'active':'']" @click="curTab=2" >施工单位</div>
        <div :class="['tab',curTab==1?'active':'']" @click="curTab=1">车队长</div>
      </div>
      <buildLoginCom :curTab="curTab"></buildLoginCom>
    </div>
  </div>
</template>

<script>
import buildLoginCom from "./buildLoginCom";
export default {
  data(){
    return {
      curTab:2
    }
  },
  components:{
    buildLoginCom
  }
};
</script>

<style lang="scss" scoped>

.login {
  display: flex;
  .left {
    position: relative;
    width: calc(100% - 520px);
    height: 100vh;
    .bottom-tags {
      position: absolute;
      bottom: 72px;
      left: 160px;
      display: flex;
      align-items: center;
      .tag {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 160px;
        height: 48px;
        border-radius: 28px;
        border: 1px solid #ffffff;
        font-weight: 500;
        font-size: 16px;
        color: #ffffff;
        margin-right: 20px;
      }
    }
    .left-bg {
      object-fit: cover;
      flex: 1;
      width: 100%;
      height: 100vh;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
    .login-text {
      position: absolute;
      top: 98px;
      left: 160px;
      .logo {
        width: 507px;
        height: 56px;
        margin-bottom: 107px;
      }
      .text1 {
        font-weight: 600;
        font-size: 4vw;
        color: #ffd703;
        margin-bottom: 12px;
        white-space: nowrap;
      }
      .text2 {
        font-weight: 400;
        font-size: 3vw;
        color: #ffffff;
        white-space: nowrap;
      }
    }
  }
  .right {
    width: 400px;
    padding-left: 56px;
    padding-right: 64px;
    background: #fff;
    position: relative;
    .right-bg{
      // object-fit: cover;
      flex: 1;
      width: 520px;
      height: 100vh;
      position: absolute;
      right: 0;
      top: 0;
      bottom: 0;
    }
    .form-header-top {
      position: relative;
      margin-top: 97px;
      margin-bottom: 32px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .title {
        font-weight: 500;
        font-size: 18px;
        color: #2e3133;
      }
      .right-text {
        cursor: pointer;
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 14px;
        color: #35b1ff;
        .active-text {
          font-weight: 400;
          font-size: 14px;
          color: #35b1ff;
          &:first-child {
            margin-right: 13px;
          }
        }
      }
    }
    .tabs {
      position: relative;
      cursor: pointer;
      display: flex;
      margin-bottom: 24px;
      // align-items: center;
      .tab {
        margin-right: 24px;
        font-weight: 400;
        font-size: 14px;
        color: #8fa5b3;
        padding: 0 8px;

        &.active {
          font-weight: 500;
          font-size: 14px;
          color: #35b1ff;
          padding-bottom: 10px;
          border-bottom: 2px solid #35B1FF;
        }
      }
    }
  }
}
@media only screen and (max-width: 1366px){
  .login{
    .right{
      width: 300px;
      .right-bg{
        width: 420px;
      }
    }
    .left{
      width: calc(100% - 420px);
    }
  }
}
</style>